export const ASCII_BANNER = `
 █████╗ ██╗  ██╗ █████╗ ██████╗ ███████╗██╗  ██╗    ████████╗██████╗ ██╗██████╗  █████╗ ████████╗██╗  ██╗██╗
██╔══██╗██║ ██╔╝██╔══██╗██╔══██╗██╔════╝██║  ██║    ╚══██╔══╝██╔══██╗██║██╔══██╗██╔══██╗╚══██╔══╝██║  ██║██║
███████║█████╔╝ ███████║██████╔╝███████╗███████║       ██║   ██████╔╝██║██████╔╝███████║   ██║   ███████║██║
██╔══██║██╔═██╗ ██╔══██║██╔══██╗╚════██║██╔══██║       ██║   ██╔══██╗██║██╔═══╝ ██╔══██║   ██║   ██╔══██║██║
██║  ██║██║  ██╗██║  ██║██║  ██║███████║██║  ██║       ██║   ██║  ██║██║██║     ██║  ██║   ██║   ██║  ██║██║
 ╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝       ╚═╝   ╚═╝  ╚═╝╚═╝╚═╝     ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝╚═╝  
`;

export const TERMINAL_CONSTANTS = {
  DEFAULT_PROMPT: "guest@192.168.1.1:~$ ",
  MAX_VISIBLE_HISTORY: 25,
  BANNER_LINE_COUNT: 7,
  BANNER_FALLBACK: "Akarsh Tripathi"
};